import React from "react";
import SignalDcIcon from "img/signal_disconnected.svg";
import { T } from "services/lang/LanguageService";

const SparkLineDisconnectedLabel = () => {
  return (
    <div className="flex align-items-end justify-content-center gap-2">
      <img src={SignalDcIcon} alt="" width={24} />
      {T("label.disconnected")}
    </div>
  );
};

export default SparkLineDisconnectedLabel;
